module.exports = __webpack_public_path__ + "static/img/facebook.bf4c187.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/aboutUs/imgs/facebook.png
// module id = RgMk
// module chunks = 1